import { writable } from 'svelte/store';
export const USER_STORE = writable({});
export const USER_HASH = writable('initial');
